const Roles = {
  ANALYTICS_COMPLIANCE: 'analytics_compliance',
  ANALYTICS_COMPLIANCE_EXEC: 'analytics_compliance_exec',
  ANALYTICS_DASHBOARD: 'analytics_dashboard',
  ANALYTICS_ONLINE_PERFORMANCE: 'analytics_online_performance',
  ANALYTICS_PRODUCTS: 'analytics_products',
  ANALYTICS_SALES_LEADERS: 'analytics_sales_leaders',
  ANALYTICS_TRAFFIC: 'analytics_traffic_summary',
  AUDIT: 'audit',
  BANK_MANAGER: 'bank_manager',
  CLIENT_MANAGER: 'client_manager',
  COMPLIANCE_DASHBOARD: 'compliance_dashboard',
  GUIDE_MANAGER: 'guide_manager',
  PRODUCT_MANAGER: 'product_manager',
  PUBLISHING: 'publishing',
  USER_MANAGER: 'user_manager'
};

export default Roles;



// WEBPACK FOOTER //
// ./src/constants/Roles.js